module.exports = __webpack_public_path__ + "4b8aee9698793cdba205fde89ee16202.svg";